import React, {memo} from 'react';

type Props = {
    title: string;
    value: string;
};

export const SettingReadOnlyRowComponent = memo(function SettingReadOnlyRowComponent({title, value}: Props) {
    return (
        <div className="line">
            <div className="left">
                <span>{title}</span>
            </div>
            <div className="right">
                <span>{value || '-'}</span>
            </div>
        </div>
    );
});
